module.exports = __webpack_public_path__ + "img/Sarah.6ed940d0.gif";